import { memo } from "react";
import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import GatterAppContent from "./GatterAppContent";

function GatterApp() {
  return (
    <div className="content" sx={{ clear: "left" }}>
      <TemplatePage type={"gatterApp"}>
        <GatterAppContent />
      </TemplatePage>
    </div>
  );
}

export default memo(GatterApp);
